// Actions
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { MapActions_fetchStaticMap } from 'app/shared/flux/actions/MapActions';

// Types
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

// Define interfaces for better type safety
interface Trace {
  finishAsyncSpan: (params: { marker: string }) => void;
}

interface ReduxStore {
  getState: () => RootReduxState;
  dispatch: ThunkDispatch<RootReduxState, undefined, AnyAction>;
}

interface ReactContext {
  store: ReduxStore;
  trace: Trace;
}

interface AreaPageResponse {
  error?: boolean;
  redirect?: boolean;
  to?: string;
  changeHttpStatus?: number;
  [key: string]: unknown;
}

const loadAreaPage = (
  reactContext: ReactContext,
  { areaResourceId }: { areaResourceId: string },
): Promise<AreaPageResponse | void | undefined> => {
  const { store, trace } = reactContext;

  return store
    .dispatch(AreaActions.loadAreaPage(areaResourceId))
    .then((response: AreaPageResponse) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#AreaActions#loadAreaPage',
      });

      if (response.error) {
        if (response.redirect && response.to) {
          return response;
        }

        store.dispatch(
          AreaActions.setCurrentArea({
            area: null,
            status: 'DATA_NOT_FOUND',
          }),
        );
        return {
          changeHttpStatus: 404,
        };
      }

      return response;
    })
    .then(async (response: AreaPageResponse) => {
      const query = store.getState().location.current.query;
      await store.dispatch(MapActions_fetchStaticMap({ area: response, query }));

      return response;
    })
    .catch((error: Error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#loadAreaPage',
          errorClass: 'AreaActions',
        }),
      );
    });
};

export default loadAreaPage;
